import { render, staticRenderFns } from "./PendingChangeModal.vue?vue&type=template&id=78d90c1d"
import script from "./PendingChangeModal.vue?vue&type=script&lang=js"
export * from "./PendingChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports